var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sc-table",
    {
      attrs: {
        data: _vm.tableData,
        loading: _vm.loading,
        "default-sort": "@timestamp",
        "default-sort-direction": "desc"
      },
      scopedSlots: _vm._u([
        {
          key: "default",
          fn: function(props) {
            return [
              _c(
                "sc-table-column",
                {
                  attrs: {
                    field: "request_uri",
                    label: "Chamada",
                    sortable: ""
                  }
                },
                [_vm._v("\n      " + _vm._s(props.row.request_uri) + "\n    ")]
              ),
              _vm._v(" "),
              _c(
                "sc-table-column",
                {
                  attrs: {
                    field: "response_status",
                    label: "Status",
                    width: "10",
                    sortable: ""
                  }
                },
                [
                  _c(
                    "sc-tag",
                    { attrs: { type: _vm.tagType(props.row.response_status) } },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(props.row.response_status) +
                          "\n      "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "sc-table-column",
                {
                  attrs: {
                    field: "request_method",
                    label: "Tipo",
                    width: "60",
                    sortable: ""
                  }
                },
                [
                  _vm._v(
                    "\n      " + _vm._s(props.row.request_method) + "\n    "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "sc-table-column",
                {
                  attrs: {
                    field: "@timestamp",
                    label: "Data",
                    width: "130",
                    sortable: ""
                  }
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm._f("date")(
                          props.row["@timestamp"],
                          "DD/MM/YYYY HH:mm:ss"
                        )
                      ) +
                      "\n    "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "sc-table-column",
                {
                  attrs: {
                    field: "ip",
                    label: "IP",
                    width: "100",
                    sortable: ""
                  }
                },
                [_vm._v("\n      " + _vm._s(props.row.remoteaddr) + "\n    ")]
              ),
              _vm._v(" "),
              _c(
                "sc-table-column",
                {
                  attrs: {
                    field: "platform",
                    label: "Plataforma",
                    sortable: ""
                  }
                },
                [_vm._v("\n      " + _vm._s(props.row.platform) + "\n    ")]
              ),
              _vm._v(" "),
              _c(
                "sc-table-column",
                { attrs: { field: "plugin", label: "Plugin", sortable: "" } },
                [_vm._v("\n      " + _vm._s(props.row.plugin) + "\n    ")]
              ),
              _vm._v(" "),
              _c(
                "sc-table-column",
                {
                  attrs: {
                    field: "type",
                    label: "Type",
                    width: "200",
                    sortable: ""
                  }
                },
                [_vm._v("\n      " + _vm._s(props.row.type) + "\n    ")]
              ),
              _vm._v(" "),
              _c(
                "sc-table-column",
                { attrs: { field: "actions", label: "Visualizar" } },
                [
                  _c(
                    "sc-field",
                    {
                      attrs: {
                        position: "is-centered",
                        addons: _vm.hasAddons(props)
                      }
                    },
                    [
                      props.row.request_body
                        ? _c(
                            "p",
                            { staticClass: "control" },
                            [
                              _c("sc-button", {
                                attrs: { theme: "primary", text: "Request" },
                                on: {
                                  click: function($event) {
                                    _vm.openRequestFilesGallery(props.index)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      props.row.response_body || props.row.response_xml
                        ? _c(
                            "p",
                            { staticClass: "control has-text-centered" },
                            [
                              props.row.response_body || props.row.response_xml
                                ? _c("sc-button", {
                                    attrs: { theme: "info", text: "Response" },
                                    on: {
                                      click: function($event) {
                                        _vm.openResponseFilesGallery(
                                          props.index
                                        )
                                      }
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  )
                ],
                1
              )
            ]
          }
        }
      ])
    },
    [
      _c(
        "template",
        { attrs: { slot: "empty" }, slot: "empty" },
        [_c("sc-table-empty")],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-65f42f88", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65f42f88","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-analytic/features/logs/pages/api/components/sc-logs-api-table/ScLogsApiTable.vue
// module id = null
// module chunks = 